
import externalLink from '~/mixins/externalLink';

/* eslint-disable max-len */
export default {
    name: 'CrowdfundHeader',
    mixins: [externalLink],
    data() {
        return {
            url: 'https://crowdcube.com/companies/clearwaste/pitches/bwGJ7b?utm_source=website&utm_medium=CC_website_banner&utm_campaign=CC_website_banner&utm_term=ClearWaste',
        };
    },
};
